import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enKE from './locales/en-KE.json'
import enAU from './locales/en-AU.json'

const targetLocale = import.meta.env.VITE_LOCALE || 'en-AU'

export const locales = {
  'en-AU': { name: 'Australia', flag: '🇦🇺', currency: 'AUD', currencySymbol: 'A$' },
  'en-KE': { name: 'Kenya', flag: '🇰🇪', currency: 'KES', currencySymbol: 'KSh' },
} as const

export type LocaleCode = keyof typeof locales

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'en-AU': { translation: enAU },
      'en-KE': { translation: enKE },
    },
    lng: targetLocale,
    fallbackLng: 'en-AU',
    supportedLngs: Object.keys(locales),
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
